
import React from 'react';
import {
  Carousel,
  CarouselContent,
  CarouselItem,
  CarouselNext,
  CarouselPrevious,
} from "@/components/ui/carousel";

const reviews = [
  {
    text: "Прекрасные свечи! Очень довольна качеством и ароматом. Обязательно закажу ещё!",
    author: "Анна К.",
    rating: 5
  },
  {
    text: "Отличный подарок для любого случая. Упаковка выше всяких похвал!",
    author: "Михаил С.",
    rating: 5
  },
  {
    text: "Использую для декора интерьера. Смотрятся великолепно!",
    author: "Елена П.",
    rating: 5
  }
];

const Reviews = () => {
  return (
    <section className="py-24 bg-wax-50">
      <div className="container px-4">
        <h2 className="font-cormorant-garamond text-4xl font-bold text-center mb-16">
          Отзывы клиентов
        </h2>
        <Carousel className="w-full max-w-4xl mx-auto">
          <CarouselContent>
            {reviews.map((review, index) => (
              <CarouselItem key={index}>
                <div className="bg-white p-8 rounded-2xl shadow-lg text-center">
                  <div className="flex justify-center mb-4">
                    {[...Array(review.rating)].map((_, i) => (
                      <span key={i} className="text-honey-500">★</span>
                    ))}
                  </div>
                  <p className="text-gray-600 mb-4 text-lg italic">"{review.text}"</p>
                  <p className="font-bold">{review.author}</p>
                </div>
              </CarouselItem>
            ))}
          </CarouselContent>
          <CarouselPrevious aria-label="Предыдущий отзыв" />
          <CarouselNext aria-label="Следующий отзыв" />
        </Carousel>
      </div>
    </section>
  );
};

export default Reviews;
